import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "bp-info-box",
	templateUrl: "./bp-info-box.component.html",
	styleUrls: ["./bp-info-box.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpInfoBoxComponent {}
